import { toast } from 'react-toastify';

export const copyContentsToClipboard = async (e?: React.MouseEvent, content?: string) => {
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }

  const textContent = String(content);

  if (!textContent) {
    return;
  }

  // 최신 Clipboard API 시도 (모바일에서도 동작하도록 이벤트 핸들러 내에서 직접 호출)
  if (navigator.clipboard && navigator.clipboard.writeText) {
    try {
      await navigator.clipboard.writeText(textContent);
      toast.success('복사되었습니다.');
      return;
    } catch (error) {
      console.error('Clipboard API failed:', error);
    }
  }

  // 폴백: document.execCommand 사용 (모바일 호환성)
  // navigator.clipboard가 없거나 실패한 경우 실행
  try {
    const textArea = document.createElement('textarea');
    textArea.value = textContent;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    textArea.style.opacity = '0';
    textArea.setAttribute('readonly', '');
    document.body.appendChild(textArea);

    // iOS Safari에서 작동하도록 select() 대신 setSelectionRange 사용
    if (navigator.userAgent.match(/ipad|iphone/i)) {
      textArea.contentEditable = 'true';
      textArea.readOnly = false;
      const range = document.createRange();
      range.selectNodeContents(textArea);
      const selection = window.getSelection();
      selection?.removeAllRanges();
      selection?.addRange(range);
      textArea.setSelectionRange(0, textContent.length);
    } else {
      textArea.select();
    }

    const successful = document.execCommand('copy');
    document.body.removeChild(textArea);

    if (successful) {
      // toast.success(t('복사되었습니다.'));
    } else {
      console.error('Fallback copy method failed');
    }
  } catch (fallbackError) {
    console.error('All copy methods failed:', fallbackError);
  }
};
